import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { SignoutCallbackComponent } from "redux-oidc";
import userManager from "../utils/userManager";
import Page from './Page';





const SignoutCallback = () => {

    const history = useHistory();

    const successCallback = () => {
        history.push("/Login");
    };

    const errorCallback = (error: Error) => {
        console.error(error);
    };

    return (
        <Page>
            <SignoutCallbackComponent
                userManager={userManager}
                successCallback={successCallback}
                errorCallback={errorCallback}>
                <div>Redirecting...</div>
            </SignoutCallbackComponent>
        </Page>
    );
}

export default SignoutCallback;